// ============================================================
// SuperAdminDashboard/index.jsx â€” Main entry point
// ============================================================

import { useContext, useState, useEffect } from "react";
import { useNavigate, Routes, Route }       from "react-router-dom";
import { Moon, Sun }                        from "lucide-react";

// Context
import { useAuth }       from "../../context/AuthContext.js";
import { ThemeContext }  from "../../constant/theme.js";
import { LanguageContext } from "../../constant/LanguageContext";

// Pages
import ConfigurationManagement from "../(SuperAdmin)ConfigurationManagement/index.js";
import AdminAccountCreation    from "../(SuperAdmin) AdminAccountCreation/index.jsx";
import Broadcasts              from "../(SuperAdmin) Broadcasts/index.jsx";
import SettingsPage            from "../(All) settings/settings.js";
import SidebarWithTopbar       from "../(All) Sidebar/SidebarWithTopbar";

// Local
import { buildNavItems }   from "./constants/navItems.js";
import useLocation         from "./hooks/useLocation.js";
import useDashboardData    from "./hooks/useDashboardData.js";
import BackgroundBlobs     from "./components/BackgroundBlobs.jsx";

// â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const getUserFromStorage = () => ({
  username: localStorage.getItem("emoloyeeName"),
  email:    localStorage.getItem("email"),
  role:     localStorage.getItem("role"),
});

// â”€â”€ Component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SuperAdminDashboard = () => {
  const { theme, setTheme } = useContext(ThemeContext);
  const { language }        = useContext(LanguageContext) || { language: "en" };
  const navItems            = buildNavItems(language);
  const { logout }          = useAuth();
  const navigate            = useNavigate();

  // Hooks
  useLocation();           // side-effect only (sets state internally if needed)
  useDashboardData();      // fetches employee + payroll data (used if stats shown)

  // UI state
  const [user]                          = useState(getUserFromStorage);
  const [notifications]                 = useState(3);
  const [sidebarOpen, setSidebarOpen]   = useState(true);
  const [currentPage, setCurrentPage]   = useState(
    () => localStorage.getItem("adminCurrentPage") || "ConfigurationManagement"
  );

  // Persist current page
  useEffect(() => {
    localStorage.setItem("adminCurrentPage", currentPage);
  }, [currentPage]);

  // â”€â”€ Actions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const toggleTheme = () =>
    setTheme(theme === "light" ? "dark" : "light");

  const handleLogout = () => {
    try {
      logout();
      ["nav_admin", "nav_manager", "nav_employee"].forEach((k) => {
        try { localStorage.removeItem(k); } catch (_) {}
      });
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      navigate("/login");
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/DashboardSuper/${page}`);
  };

  // â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  return (
    <div
      style={{
        minHeight:  "100vh",
        fontFamily: "Segoe UI, Roboto, sans-serif",
        position:   "relative",
      }}
    >
      <BackgroundBlobs />

      <SidebarWithTopbar
        navItems={navItems}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        user={user}
        notifications={notifications}
        handleLogout={handleLogout}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        themeToggle={
          <button
            onClick={toggleTheme}
            style={{
              padding:      "8px",
              borderRadius: "12px",
              cursor:       "pointer",
              color:        theme === "light" ? "#0f172a" : "white",
              background:   theme === "light"
                ? "rgba(0,0,0,0.1)"
                : "rgba(255,255,255,0.1)",
            }}
          >
            {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
          </button>
        }
      >
        <div style={{ padding: "32px 24px" }}>
          <Routes>
            <Route path="/ConfigurationManagement" element={<ConfigurationManagement />} />
            <Route path="/AdminAccountCreation"    element={<AdminAccountCreation />}    />
            <Route path="/Broadcasts"              element={<Broadcasts />}              />
            <Route path="/Settings"                element={<SettingsPage />}             />
          </Routes>
        </div>
      </SidebarWithTopbar>
    </div>
  );
};

export default SuperAdminDashboard;